import { useState, useEffect } from "react";

export default function AdminPanel({ supabase, C, ColHeader }) {
  const [stats,setStats]     = useState(null);
  const [loading,setLoading] = useState(true);
  const [open,setOpen]       = useState(false);

  useEffect(()=>{
    if(!open) return;
    const load = async()=>{
      setLoading(true);
      try {
        const { data, error } = await supabase.rpc("get_admin_stats");
        if(error) throw error;
        setStats(data);
      } catch(e){
        console.log("Admin error:",e.message);
      }
      setLoading(false);
    };
    load();
  },[open]);

  return (
    <div style={{background:`${C.accent}10`,borderRadius:14,marginBottom:16,border:`1px solid ${C.border}`,overflow:"hidden"}}>
      <button onClick={()=>setOpen(p=>!p)} style={{width:"100%",background:"none",border:"none",padding:"14px 18px",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer"}}>
        <ColHeader style={{margin:0,color:C.accent}}>👑 Usage dashboard</ColHeader>
        <span style={{fontSize:14,color:C.muted,transition:"transform 0.2s",transform:open?"rotate(180deg)":"rotate(0deg)"}}>▾</span>
      </button>
      {open&&(
        <div style={{padding:"0 18px 18px"}}>
          {loading?(
            <p style={{fontFamily:"sans-serif",fontSize:13,color:C.muted}}>Loading...</p>
          ):!stats?(
            <p style={{fontFamily:"sans-serif",fontSize:13,color:C.faint,fontStyle:"italic"}}>No data yet</p>
          ):(
            <>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:16}}>
                <div style={{background:C.card,borderRadius:10,padding:"12px 14px",textAlign:"center"}}>
                  <p style={{margin:0,fontSize:28,fontWeight:"bold",color:C.dark,fontFamily:"sans-serif"}}>{stats.total}</p>
                  <p style={{margin:"2px 0 0",fontSize:11,fontFamily:"sans-serif",color:C.muted,textTransform:"uppercase",letterSpacing:1}}>Total users</p>
                </div>
                <div style={{background:C.card,borderRadius:10,padding:"12px 14px",textAlign:"center"}}>
                  <p style={{margin:0,fontSize:28,fontWeight:"bold",color:C.holiday,fontFamily:"sans-serif"}}>{stats.active}</p>
                  <p style={{margin:"2px 0 0",fontSize:11,fontFamily:"sans-serif",color:C.muted,textTransform:"uppercase",letterSpacing:1}}>Active (30d)</p>
                </div>
              </div>

              {stats.countries?.length>0&&(
                <div>
                  <ColHeader style={{marginBottom:8}}>Users by country</ColHeader>
                  <div style={{background:C.card,borderRadius:10,padding:"10px 12px"}}>
                    {stats.countries.map((c,i)=>(
                      <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"5px 0",borderBottom:i<stats.countries.length-1?`1px solid ${C.border}`:"none"}}>
                        <span style={{fontSize:13,fontFamily:"sans-serif",color:C.dark}}>{c.country||"Unknown"}</span>
                        <div style={{display:"flex",alignItems:"center",gap:8}}>
                          <div style={{width:60,height:4,borderRadius:2,background:C.border,overflow:"hidden"}}>
                            <div style={{width:`${(c.count/stats.total)*100}%`,height:"100%",background:C.accent,borderRadius:2}}/>
                          </div>
                          <span style={{fontSize:12,fontFamily:"sans-serif",color:C.muted,minWidth:16,textAlign:"right"}}>{c.count}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                  <p style={{margin:"10px 0 0",fontSize:10,fontFamily:"sans-serif",color:C.faint,textAlign:"center",fontStyle:"italic"}}>
                    Activity and country only — no content accessed
                  </p>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}
